"use client";

import { type TextFieldAria } from "@react-aria/textfield";
import { type ReactNode, useMemo, useState } from "react";

import { cn } from "../../utils";
import { TextFieldRootContext, type TextFieldRootInterface } from "./context";

export type TextFieldRootProps = {
  children: ReactNode;
  className?: string;
};

const Root = ({ children, className }: TextFieldRootProps) => {
  const [textField, setTextField] = useState<TextFieldAria<"input" | "textarea">>();
  const providerValue = useMemo<TextFieldRootInterface<"input" | "textarea">>(
    () => ({
      textField,
      setTextField,
    }),
    [textField]
  );

  return (
    <TextFieldRootContext value={providerValue}>
      <div className={cn("flex flex-col gap-1.5", className)}>{children}</div>
    </TextFieldRootContext>
  );
};

export default Root;
